import { PointSettings } from '../../../types/metadata';

export const DEFAULT_POINT_SETTINGS: PointSettings = {
  markerType: "dot",
  color: [255, 0, 0],
  size: 3,
  borderColor: [255, 255, 255],
  borderSize: 1,
  opacity: 1,
  heatmapType: 'hex',
  heatmapPrimaryColor: [255, 0, 0],
  heatmapSecondaryColor: [255, 255, 255],
  heatmapStroke: 0,
  heatmapStrokeColor: [0, 0, 0],
  heatmapOpacity: .1,
  heatmapThreshold: 500,
  heatmapRadiusPixels: 30,
  heatmapIntensity: 0.75,
  heatmapCloudThreshold: 0.05,
};
